var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9095_5711)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9095_5711",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9095_5711)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9095_5711",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9095_5711)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9095_5711",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9095_5711)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9095_5711",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9095_5711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "#CurrentColor"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9095_5711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3361 4.7268H13.8433L13.742 4.27157C13.7072 4.11295 13.5663 4.00002 13.4037 4.00002H10.5958C10.4333 4.00002 10.2929 4.11295 10.2575 4.27157L10.1567 4.7268H7.66337C6.75133 4.7268 6.00977 5.46863 6.00977 6.38067V18.3462C6.00977 19.2582 6.75133 20 7.66337 20H16.3362C17.2482 20 17.9903 19.2582 17.9903 18.3462V6.38067C17.9903 5.46863 17.2482 4.7268 16.3361 4.7268ZM16.9094 18.3461C16.9094 18.662 16.6523 18.9191 16.3361 18.9191H7.66334C7.3477 18.9191 7.09066 18.662 7.09066 18.3461V6.38067C7.09066 6.06476 7.3477 5.80775 7.66334 5.80775H9.91648L9.85897 6.06636C9.83573 6.169 9.86108 6.27667 9.92654 6.35852C9.99248 6.44059 10.0923 6.48835 10.1972 6.48835H13.8027C13.9077 6.48835 14.0075 6.44059 14.0729 6.35852C14.1389 6.27644 14.1642 6.16904 14.141 6.06636L14.0835 5.80775H16.3361C16.6523 5.80775 16.9094 6.0648 16.9094 6.38067V18.3461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80624 10.4041H11.2761L10.9268 10.1655C10.4338 9.82906 10.3071 9.15632 10.6439 8.66337C10.9801 8.17093 11.653 8.04348 12.146 8.38046L12.2036 8.41979V8.00732C12.2036 7.73998 11.9866 7.52307 11.7195 7.52307H9.80624C9.53921 7.52307 9.32227 7.74001 9.32227 8.00732V9.91981C9.32227 10.1872 9.53921 10.4041 9.80624 10.4041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3068 7.74923L12.6125 9.35321L11.8409 8.82675C11.5955 8.65811 11.2587 8.72197 11.0898 8.96821C10.9214 9.21465 10.9848 9.55088 11.2318 9.71925L12.3629 10.4917C12.4553 10.555 12.5613 10.5859 12.6675 10.5859C12.802 10.5859 12.9355 10.5358 13.039 10.4378L15.0499 8.53409C15.2669 8.32905 15.2758 7.98676 15.071 7.7701C14.8652 7.55343 14.5237 7.54418 14.3068 7.74923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80624 14.1169H11.2767L10.9268 13.8781C10.4338 13.5416 10.3071 12.8689 10.6439 12.376C10.9801 11.8832 11.653 11.7558 12.146 12.093L12.2036 12.1324V11.7199C12.2036 11.4526 11.9866 11.2357 11.7195 11.2357H9.80624C9.53921 11.2357 9.32227 11.4526 9.32227 11.7199V13.6327C9.32227 13.9 9.53921 14.1169 9.80624 14.1169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3068 11.462L12.6125 13.0658L11.8409 12.5393C11.5955 12.3704 11.2587 12.434 11.0898 12.6807C10.9214 12.9273 10.9848 13.2634 11.2318 13.4318L12.3629 14.2043C12.4553 14.2676 12.5613 14.2985 12.6675 14.2985C12.802 14.2985 12.9355 14.2483 13.039 14.1504L15.0499 12.2469C15.2669 12.0419 15.2758 11.6998 15.071 11.4829C14.8652 11.2662 14.5237 11.2572 14.3068 11.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7195 14.9484H9.80624C9.53921 14.9484 9.32227 15.1654 9.32227 15.4327V17.3452C9.32227 17.6125 9.53921 17.8294 9.80624 17.8294H11.7195C11.9866 17.8294 12.2036 17.6125 12.2036 17.3452V15.4327C12.2036 15.1654 11.9866 14.9484 11.7195 14.9484Z",
    fill: "white"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9095_5711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9095_5711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.f6de40093c2a705dd01dbb9aef635afb.svg";
export { ForwardRef as ReactComponent };